import Vue from 'vue'
import VueResource from 'vue-resource'
Vue.use(VueResource)

const API_URL = process.env.API_URL

export default {
  data: {},
  packageData: require('../../package.json'),

  query () {
    return new Promise((resolve, reject) => {
      if (this.data && this.data.length) resolve(this.data)

      Vue.http.get(`${API_URL}setup`)
      .then(response => {
        this.data = response.body
        resolve(this.data)
      }, response => {
        console.error(`Error fetching setup data`, response)
      })
    })
  },
  create (data) {
    return Vue.http.post(`${API_URL}setup`, data)
  },
  update (data) {
    return Vue.http.put(`${API_URL}setup`, data)
  },
  checkKeyExists (key) {
    return Vue.http.post(`${API_URL}setup/key/`, {key: key})
  },
  fetch () {
    return Vue.http.get(`${API_URL}setup`, {params: {full: true}})
  }
}



// WEBPACK FOOTER //
// ./src/services/setup.js